import React, { useState } from "react";
import { Derivaciones } from "./Derivaciones";
import { Header, Modal } from "semantic-ui-react";
import Swal from "sweetalert2";
import { Navigate, useNavigate } from "react-router-dom";
import { Estados } from "../Otros/Estados";
import { fechaHumana } from "../../utils/Util";
import { acusoRecibo } from "../../utils/Datos";
import { selectUser, logout } from "../../reducers/userSlice";
import { useSelector } from "react-redux";

export const ItemLista = ({ solicitud }) => {
  const [open, setOpen] = useState(false);
  const user = useSelector(selectUser);

  const handleAcusarRecibo = () => {
    let payload = {
      id_request_neighbor : solicitud.id_request_neighbor,
      user_session : user.user.run
    }

    acusoRecibo(payload).then((respuesta)=>{
      if (respuesta.status) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: "Se acusó recibo correctamente",
        }).then((okay)=>{
          if (okay) {
            window.location.href = "/home";
          }
        });
        setOpen(false);
      }else{
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo acusar recibo",
        });
      }
    })


  };

  const navigate = useNavigate();

  const modalAcusarRecibo = (id_request_neighbor) => {
    return (
      <Modal
        className="pb-2 pb-md-0"
        closeIcon
        open={open}
        trigger={
          !solicitud.isAcusaReceive &&
          <button className="btn btn-warning btn-sm text-dark">
            <strong><i className="fas fa-check mr-2 text-dark"></i>Acusar Recibo</strong>
          </button>
        }
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Header
          icon="archive"
          content={`Acusar recibo solicitud #${id_request_neighbor}`}
        />
        <Modal.Content>
          <p>
            Está seguro que quiere acusar el recibo de la solicitud #
            {id_request_neighbor}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="btn btn-danger me-4"
            onClick={() => setOpen(false)}
          >
            No, volver
          </button>
          <button
            className="btn btn-success"
            onClick={() => handleAcusarRecibo()}
          >
            Si, acusar recibo
          </button>
        </Modal.Actions>
      </Modal>

    );
  };

  return (
    <div className="card card-bordered w-100 mb-5 pb-5 mt-5">
      <div className="card-head px-10 py-5 d-grid d-md-flex justify-content-md-between">
        <h3 className="text-gray-700"><span className="badge badge-info badge-lg me-4" style={{fontSize:15}}><b>ID: {solicitud.id_request_neighbor}</b> </span> Título: {solicitud.title} </h3>
        {solicitud.state == "CERRADA" && !solicitud.acusaRecibo ? (
          modalAcusarRecibo(solicitud.id_request_neighbor)
        ) : (
          <></>
        )}
      </div>
      <div className="card-head px-10 py-2 d-inline-block d-md-flex border-bottom border-2 border-opacity-50 border-secondary">
        <div className="d-flex flex-column flex-grow-1 pe-5">

          <div className="row">
            <div className="fw-bold fs-5 lh-lg mb-2" style={{width: 100}}>
              Temas
            </div>
            <div className="col fs-5 lh-lg text-start ms-4">
              {solicitud.request_thematics.map((tema, index) => {
                return (
                  <div key={index} className="tag-tema d-inline-block">
                    <span className="badge badge-light-info badge-lg me-2">
                      {tema.thematic.name_thematic}
                    </span>
                  </div>
                );
              })}
            {solicitud.request_thematics.length == 0 ? <span className="text-muted"><i className="fas fa-info me-2"></i>No se seleccionaron temáticas</span>: <></>}
          </div>
        </div>
      </div>

        <div className="d-flex flex-column pe-10">
          <div className="row" style={{width: 250}}>
            <div className="col d-inline-block fw-bold fs-5 lh-lg" style={{width: 100}}>Creado el</div>

            <div className="col d-inline-block fs-5 lh-lg ms-4 mb-2 text-muted text-bold" style={{width: 150}}>
              {fechaHumana(solicitud.created_date)}
            </div>
          </div>

          <div className="row" style={{width: 250}}>
            <div className="col fw-bold fs-5 lh-lg" style={{width: 100}}>Estado</div>
            <div className="col fs-5 lh-lg text-start ms-4" style={{width: 150}}>
              <Estados estado={solicitud.state} />
            </div>
          </div>
        </div>

        <div className="d-flex flex-column">
          <div className="fw-bold fs-5 lh-lg">&nbsp;</div>
          <button
          style={{width: 150}}
            className="btn btn-primary btn-sm"
            onClick={() =>
              navigate("/VerSolicitud/" + solicitud.id_request_neighbor)
            }
          >
            <strong>Ver detalle</strong>
          </button>
        </div>
      </div>
      <div className="card-body py-0">
        <Derivaciones
          titulo={solicitud.title}
          id_request_neighbor={solicitud.id_request_neighbor}
        ></Derivaciones>
      </div>
    </div>
  );
};
